import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Lost / Stolen',
		url: '/losses',
		icon: 'question',
	}
];

export default class Losses extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button onClick={this.toggle('modalLoss')} size="sm" color="primary">
						<i className="fa fa-question"/>&nbsp;&nbsp;Add Loss
					</Button>
				</Framework.Components.PageBar>

				<Collections.Losses
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					scannedCode={!this.state['modalLoss'] ? this.props.scannedCode : null}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name={"Loss"}
					object={Objects.Loss}
					history={this.props.history}
					toggle={this.state['modalLoss']}
					reportClose={this.reportClose('modalLoss')}
					afterSave={this.handleAfterSave}
					objectProps={{scannedCode: this.state['modalLoss'] ? this.props.scannedCode : null}}
				/>

			</div>
		);
	}
}

